<template>
  <div id="Luzhufenxi">
    <div class="tr-header">
      <p v-if="device!='mobile'" class="title">露珠分析</p>
      <div class="dayHandles">
        <DatePick @onchange="onchangeDate"></DatePick>
      </div>
    </div>
    <div class="tr-header-container">
      <div class="handle-con">
        <div class="title">
          <span>筛选名称</span>
          <div class="handles" style="padding-left:20px">
            <CheckboxGroup v-model="selectRank">
              <Checkbox :label="it.key" v-for="(it,i) in Ranks" :key="i">{{it.name}}</Checkbox>
            </CheckboxGroup>
            <span @click="handleChoiceAll">全选</span>
            <span @click="selectRank = []">清空</span>
          </div>
        </div>
        <div class="title">
          <span>筛选路珠</span>
          <div class="handles" style="display:inline-block;padding-left:20px">
            <CheckboxGroup v-model="selectRoad">
              <Checkbox :label="it.key" v-for="(it,i) in Roads" :key="i">{{it.name}}</Checkbox>
            </CheckboxGroup>
          </div>
        </div>
      </div>
    </div>
    <div class="tr-table-container" v-if="Object.keys(roadsData).length">
      <template v-for="(it,i) in roadsData" v-if="~selectRank.indexOf(i)">
        <Road
          v-for="(is,j) in it"
          v-if="~selectRoad.indexOf(j)"
          :key="i+j"
          :data="is"
          :rank="i"
          :road="j"
          :date="curDate"
          :ranks="Ranks"
          :roads="Roads"
        ></Road>
      </template>
      <div>
        <p v-if="$route.params.betType=='choose5'">
          号码大于等于6为大，小于等于5为小，开出11为和。
          <br />开出双数叫双，开出单数叫单。
          <br />注："和"只对1-5球生效。
          <br />龙虎：开出号码中，第一球大于第五球为龙，反之为虎。
          <br />和尾大小：总和的个位数的大小，0-4为小，5-9为大。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import DatePick from "../components/DatePick";
import dayjs from "dayjs";
import statistic from "../../../helpers/statistic";
import Road from "./Road";
import { mapState } from "vuex";
const sscRanks = [
  {
    name: "第一球",
    key: "0"
  },
  {
    name: "第二球",
    key: "1"
  },
  {
    name: "第三球",
    key: "2"
  },
  {
    name: "第四球",
    key: "3"
  },
  {
    name: "第五球",
    key: "4"
  },
  {
    name: "总和",
    key: "count"
  },
  {
    name: "尾和",
    key: "tailCount"
  }
];
const Roads = [
  {
    name: "大小路珠",
    key: "smallBig"
  },
  {
    name: "单双路珠",
    key: "singleDouble"
  },
  {
    name: "龙虎",
    key: "dragonTiger"
  }
];
const pk10Ranks = [
  {
    name: "冠军",
    key: "0"
  },
  {
    name: "亚军",
    key: "1"
  },
  {
    name: "第三名",
    key: "2"
  },
  {
    name: "第四名",
    key: "3"
  },
  {
    name: "第五名",
    key: "4"
  },
  {
    name: "第六名",
    key: "5"
  },
  {
    name: "第七名",
    key: "6"
  },
  {
    name: "第八名",
    key: "7"
  },
  {
    name: "第九名",
    key: "8"
  },
  {
    name: "第十名",
    key: "9"
  },
  {
    name: "冠亚和",
    key: "gyh"
  }
];

export default {
  name: "Luzhufenxi",
  components: {
    DatePick,
    Road
  },
  data() {
    return {
      date: dayjs().format("YYYYMMDD"),
      Ranks: [],
      Roads: [],
      selectRank: [],
      selectRoad: [],
      dataSource: [],
      selectDay: dayjs().format("YYYYMMDD")
    };
  },
  computed: {
    curDate() {
      return dayjs(this.selectDay).format("YYYY-MM-DD");
    },
    ...mapState(["device"]),
    betType() {
      return this.$route.params.betType;
    },
    roadsData() {
      return statistic.getRoads(
        this.betType,
        this.dataSource,
        this.selectRank,
        this.selectRoad
      );
    }
  },
  created() {
    this.reset();
  },
  methods: {
    handleChoiceAll() {
      this.Ranks.map(it => {
        this.selectRank.push(it.key);
      });
    },
    onchangeDate(date) {
      this.selectDay = date;
      this.getData();
    },
    reset() {
      if (this.betType == "ssc" || this.betType == "choose5") {
        this.Ranks = sscRanks;
        this.Roads = Roads;
        this.selectRank = this.Ranks.map(x => x.key);
        this.selectRoad = this.Roads.map(x => x.key);
      }
      if (this.betType == "PK10" || this.betType == "nn") {
        this.Ranks = pk10Ranks;
        this.Roads = Roads;
        this.selectRank = this.Ranks.map(x => x.key);
        this.selectRoad = this.Roads.map(x => x.key);
      }
    },
    async init() {
      // this.reset();
      this.getData();
    },
    async getData() {
      let res = await this.$http.post("/queryGameTypeResultByGameType.do", {
        gameType: this.$route.params.gameType,
        startDate: this.selectDay,
        endDate: this.selectDay
      });
      if (res.data.returnCode == "0000") {
        this.dataSource = res.data.returnList;
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    }
  }
};
</script>
<style lang="less" scoped>
#Luzhufenxi {
  .dayHandles {
    position: absolute;
    right: 0;
    margin-right: 20px;
  }
  .title {
    display: flex;
    span {
      white-space: nowrap;
    }
  }
  .handles {
    display: flex;
    span {
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Luzhufenxi/index.vue